/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%]{display:block;width:2rem;text-align:center;border:1px solid rgba(0,0,0,.5);border-radius:3px;outline:0;font-size:1.2rem;padding:.2rem}.dot[_ngcontent-%COMP%]{width:4px;height:4px;background-color:#000;border-radius:50%}"];
export { styles as styles };
